import defaultsDeep from 'lodash.defaultsdeep';

/**
 * Request svg icon
 *
 * @param {string} name name of icon
 * @param {string} classes additional comma-separated icon classes - besides 'icon'
 * @param {function} callback function to process retunred icon
 * @returns {Object} dom node
 */
export const svgIcon = (name, classes, callback) => {
	var path = `/assets/img/icons/${name}.svg`;
	var existingIcon = document.querySelector(`.icon.${name}`);

	var fetchIcon = () => {
		var xhr = new XMLHttpRequest();
        xhr.open('GET', path, true);
        xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				var icon = document.importNode(xhr.responseXML.documentElement,true);
				callback(createIcon(icon.outerHTML));
			}
        };
		xhr.send(null);
	};

	var createIcon = (icon) => {
		var iconTemplate = `<i class="icon ${name} ${classes ? classes : ''}">${icon}</i>`;
		var temp = document.createElement('temp');
		temp.innerHTML = iconTemplate;
		return temp.firstChild;
	}

	return existingIcon ? callback(createIcon(existingIcon.innerHTML)) : fetchIcon();
}

/**
 * @param {Object} el dom node to be scrolled
 * @param {number} x destination cordinate
 * @param {number} y destination cordinate
 */
export const smoothScroll = (el, x, y, callback) => {
	var now = window.performance && window.performance.now ? window.performance.now.bind(window.performance) : Date.now;
	var SCROLL_TIME = 468;

	var scrollable;
	var startX;
	var startY;
	var method;
	var startTime = now();

	// define scroll context
	scrollable = window;
	startX = window.scrollX || window.pageXOffset;
	startY = window.scrollY || window.pageYOffset;
	method = window.scroll || window.scrollTo;

	var smoothScrollStep = context => {
		var time = now();
		var value;
		var currentX;
		var currentY;
		var elapsed = (time - context.startTime) / SCROLL_TIME;

		// avoid elapsed times higher than one
		elapsed = elapsed > 1 ? 1 : elapsed;

		// apply easing to elapsed time
		value = 0.5 * (1 - Math.cos(Math.PI * elapsed));

		currentX = context.startX + (context.x - context.startX) * value;
		currentY = context.startY + (context.y - context.startY) * value;

		context.method.call(context.scrollable, currentX, currentY);

		// scroll more if we have not reached our destination
		if (currentX !== context.x || currentY !== context.y) {
			window.requestAnimationFrame(smoothScrollStep.bind(window, context));
		} else {
			if (typeof callback === "function") {
				callback();
			}
		}
	}

	// scroll looping over a frame
	smoothScrollStep({ scrollable: scrollable, method: method, startTime: startTime, startX: startX, startY: startY, x: x, y: y});
}

export const isUrl = (str) => {
    var pattern = /^(https:\/\/|http:\/\/)?((([-_0-9a-z\x80-\xFF]+\.)*[0-9a-z\x80-\xFF]([-0-9a-z\x80-\xFF]{0,61}[0-9a-z\x80-\xFF])?\.)[a-z\x80-\xFF]([-0-9a-z\x80-\xFF]{0,17}[a-z\x80-\xFF]))(:\d{1,5})?(\/\S*)?$/;
    return pattern.test(str);
}

export const isMailto = (str) => {
    var pattern = /^mailto:\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str);
}

export const isEmail = (str) => {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str);
}

export const isExternalUrl = (current, toCheck) => {
	var extractHostname = url => {
		var hostname;
		//find & remove protocol (http, ftp, etc.) and get hostname

		if (url.indexOf("//") > -1) {
			hostname = url.split('/')[2];
		}
		else {
			hostname = url.split('/')[0];
		}

		//find & remove port number
		hostname = hostname.split(':')[0];
		//find & remove "?"
		hostname = hostname.split('?')[0];

		return hostname;
	}

	var currentHostname = extractHostname(current);
	var externalHostname = extractHostname(toCheck);

	var externalHostnameVariants = [];

	externalHostnameVariants.push(externalHostname);

	// consider both with and without 'www.' as same hostnames
	if (externalHostname.substring(0, 4) === 'www.') {
		externalHostnameVariants.push(externalHostname.slice(4));
	} else {
		externalHostnameVariants.push("www." + externalHostname);
	}

	// if non of external variants matches current hostname it means url is external
	return externalHostnameVariants.indexOf(currentHostname) < 0;
}

export const getRelativeURL = url => {
	//find & remove protocol (http, ftp, etc.) and get hostname
	if (url.indexOf("//") > -1) {
		url = url.split('//')[1];
		url = url.split(/\/(.+)/);
	}
	else {
		url = url.split(/\/(.+)/);
	}

	return url[1] ? "/" + url[1] : "/";
}

/**
 * Gets a param from the search part of a URL by name.
 * @param {string} param URL parameter to look for.
 * @return {string|undefined} undefined if the URL parameter does not exist.
 */
export const getURLParameter = param => {
	if (!window.location.search) {
		return;
	}

	var m = new RegExp(param + '=([^&]*)').exec(window.location.search.substring(1));

	if (!m) {
		return;
	}

	return decodeURIComponent(m[1]);
}

/**
 * Gets host name from passed url
 * @param {string} url URL.
 * @return {string|null} null if the URL is invalid
 */
export const getHostName = url => {
	var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);

    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    	return match[2];
    }
    else {
        return null;
    }
}

/**
 * Gets domain from passed url
 * @param {string} url URL.
 * @return {string} domain
 */
export const getDomain = url => {
    var hostName = getHostName(url);
    var domain = hostName;

    if (hostName != null) {
        var parts = hostName.split('.').reverse();

        if (parts != null && parts.length > 1) {
            domain = parts[1] + '.' + parts[0];

            if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
              domain = parts[2] + '.' + domain;
            }
        }
    }

    return domain;
}

/**
 * Returns base url of requested url part
 * @param {string} prefix
 * @return {string} base url
 */
export const baseUrl = prefix => {
    const locationHref = window.location.href;
    const domain = getDomain(locationHref);
    const portSuffix = [80, 443, 0, ''].includes(window.location.port) ? '' : `:${window.location.port}`;
    let hostname = domain;

    if (locationHref.includes('pixenio.prod.pxn')) {
        hostname = `pixenio.${domain}`;
    } else if (locationHref.includes('dev.pixen.io')) {
        hostname = `dev.${domain}`;
    }

    return `${window.location.protocol}//${prefix}.${hostname}${portSuffix}`
}

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
export const masonry = (el, defaults) => {
    const options = defaultsDeep({}, defaults || {}, {
        itemSelector: ".masonry-item",
        columnWidth: ".masonry-grid-sizer",
        percentPosition: true,
        gutter: ".masonry-gutter-sizer",
        transitionDuration: 0,
        layoutOnImagesLoaded: true
    });

    var masonry = new Masonry(el, defaultsDeep({}, {}, options));

    if (options.layoutOnImagesLoaded) {
        imagesLoaded(el).on( 'progress', () => {
            masonry.layout();
        });
    }

    return masonry;
}

import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export class Lightbox {
    constructor(gallery, id, config) {
        this.gallery = gallery;
        this.id = id;

        this.config = defaultsDeep({}, config, {
            gallery: '.lb-gallery',
            modal: '.pswp',
            item: '.lb-item',
            itemSrc: 'href',
            itemMsrc: 'data-thumb',
            itemSize: 'data-size',
            itemIndex: 'data-index',
            itemTitle: 'data-title',
            photoSwipe: {
                mainClass: 'pswp--minimal--dark',
                captionEl: false,
                tapToClose: true,
                shareEl: false,
                fullscreenEl: false,
                barsSize: {
                    top: 0, bottom: 'auto'
                },
                getThumbBoundsFn: this.getThumbPos.bind(this),
                getDoubleTapZoom: this.getZoomLevel
            }
        });

        this.data = {
            modal: null,
            items: []
        }

        this.init();
    }

    init() {
        const modal = document.querySelector(this.config.modal);
        if (!modal) return;
        this.data.modal = modal;

        const items = this.gallery.querySelectorAll(this.config.item);

        this.prepareItems(items);

        const hashData = this.parseHash();
        if(hashData.hasOwnProperty('pid') && hashData.hasOwnProperty('gid') && hashData.gid == this.id) {
            this.initPhotoSwipe(hashData.pid);
        }

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            item.setAttribute(this.config.itemIndex, i);
            item.addEventListener('click', e => {
                e.preventDefault();
                this.initPhotoSwipe(i);
            });
        }
    }

    prepareItems(nodes) {
        var items = nodes;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            var itemSize = item.getAttribute(this.config.itemSize).split('x');

            this.data.items.push({
                src: item.getAttribute(this.config.itemSrc),
                w: itemSize[0],
                h: itemSize[1],
                msrc: item.querySelector('img') ? item.querySelector('img').getAttribute('src') : item.getAttribute(this.config.itemMsrc),
                title: item.getAttribute(this.config.itemTitle),
            });
        }
    }

    initPhotoSwipe(index = 0) {
        const options = Object.assign({}, this.config.photoSwipe, {
            galleryUID: this.id,
            index: index
        });

        const lightBox = new PhotoSwipe(this.data.modal, PhotoSwipeUI_Default, this.data.items, options);
        lightBox.init();
        lightBox.listen('destroy', this.config.onDestroy);

    }

    update() {
        const items = this.gallery.querySelectorAll(`${this.config.item}:not([data-index])`);
        const lastIndex = this.data.items.length;

        this.prepareItems(items);

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const currentIndex = lastIndex + i;

            item.setAttribute(this.config.itemIndex, currentIndex);
            item.addEventListener('click', e => {
                e.preventDefault();
                this.initPhotoSwipe(currentIndex);
            });
        }
    }

    getThumbPos(index) {
        var thumb = this.gallery.querySelectorAll(this.config.item)[index],
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumb.getBoundingClientRect();

        return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
    }

    getZoomLevel(isMouseClick, item) {
        if (isMouseClick) {
            return document.documentElement.clientWidth / item.w;
        } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.5;
        }
    }

    parseHash() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if(pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1] == 1 ? 0 : parseInt(pair[1], 10);
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    }
}

